import { FC } from "react";
import { Helmet } from "react-helmet";
import { routes } from "~/constants";
import { canonical } from "~/utils/canonical";

const text = {
  description: "",
  pageTitle: "Welcome",
};

export const Meta: FC = () => {
  return (
    <Helmet>
      <title itemProp="name" lang="en">
        {text.pageTitle}
      </title>
      <meta name="description" content={text.description} />
      {canonical(routes.interstitialWelcome)}
    </Helmet>
  );
};
